import FormFieldOptionInterface from '@vertical-plus/vue-js-components/lib/model/vos/form/form-field-option-interface';
import GetTeamsTask from '@/model/task/organisation/get-teams-task';
import MicroServiceUserService from '@vertical-plus/vue-js-micro-service-components/lib/model/service/organisation/user-service';
import Team from '@/model/entity/organisation/team';
import TeamSearchResultsVo from '@/model/vo/organisation/team-search-results-vo';
import User from '@vertical-plus/vue-js-micro-service-components/lib/model/entity/organisation/user';

export default class UserService extends MicroServiceUserService
{
    private cachedAllUsers: FormFieldOptionInterface[]|null = null;

    public async loadUser(id: string): Promise<User|null>
    {
        const results = await this.findUsers({
            id: [ id ],
            itemsPerPage: 1,
        });

        return results.results.length > 0 ? results.results[0] : null;
    }

    public async formOptionsCallback(search: string): Promise<FormFieldOptionInterface[]>
    {
        // Cache all users if not already cached
        if (!this.cachedAllUsers)
        {
            await this.cacheAllUsers();
        }

        // If no search term, return all users
        if (search)
        {
            const isearch = search.toLowerCase();

            return (this.cachedAllUsers ?? []).filter(option => option.value === search || option.title.toLowerCase().includes(isearch));
        }
        else
        {
            return this.cachedAllUsers ?? [];
        }
    }

    public async formTitlesCallback(values: string[]): Promise<Record<string, string>>
    {
        // Cache all users if not already cached
        if (!this.cachedAllUsers)
        {
            await this.cacheAllUsers();
        }

        const options: Record<string, string> = {};

        if (this.cachedAllUsers)
        {
            for (const option of this.cachedAllUsers)
            {
                if (values.includes(option.value as string))
                {
                    options[option.value as string] = option.title;
                }
            }
        }

        return options;
    }

    /**
     * Caches all users
     */

    private async cacheAllUsers()
    {
        const users = await this.findUsers({
            disabled: false,
            itemsPerPage: 1000,
            order: [
                {
                    key: 'firstName',
                    descending: false,
                },
                {
                    key: 'lastName',
                    descending: false,
                },
            ],
        });

        const options: FormFieldOptionInterface[] = [];

        for (const user of users.results)
        {
            options.push({
                value: user.id,
                title: user.fullName,
            });
        }

        this.cachedAllUsers = options;
    }

    /**
     * Returns legacy V+ Admin team relating to the given user
     *
     * @param userId
     */

    public async getUserLegacyTeam(userId: string): Promise<Team|null>
    {
        const task = new GetTeamsTask();
        task.token = this.token;
        task.searchConditions = {
            'users.id': userId,
            'itemsPerPage': 1,
        };

        const results = await (this.runTask(task) as Promise<TeamSearchResultsVo>);

        return results.results.length > 0 ? results.results[0] : null;
    }
}